export default __webpack_public_path__ + "static/media/eric.ddcd5bdb.png";